export default {
  main: {
    currency: 'EUR.',
    button_success: 'Ок',
    button_apply: 'OK',
    button_save: 'Speichern',
    button_save_and_send_mails: 'Email versenden',
    button_copy: 'Duplizieren',
    warning_copy: 'Wollen Sie dieses Protokoll duplizieren? Dabei werden alle Daten außer Unterschriften und Email-Adressen übernommen.',
    button_delete: 'Löschen',
    delete_warning: 'Möchten Sie dieses Protokoll wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    button_delete_room: 'Raum löschen',
    delete_room_warning: 'Möchten Sie diesen Raum wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    button_cancel: 'Abbrechen',
    button_clear: 'Clear',
    button_add: 'Neus Protokoll+',
    button_add_user: 'Benutzer hinzufügen',
    button_add_image: 'Bild hinzufügen +',
    button_get_pdf: 'PDF generieren',
    button_synchronize: 'Synchronisieren',
    button_logout: 'Abmelden',
    images: 'images',
    image: 'image',
    out_of_sync: 'Nicht synchronisiert',
    protocols: 'Protokolle',
    boolean: {
      true: 'Ja',
      false: 'Nein'
    },
    login: 'Name',
    button_login: 'Anmelden',
    auth_header: 'Anmeldung',
    password: 'Passwort',
    isset_protocol_local_version: 'Wichtig! Für dieses Protokoll existiert bereits eine lokale nicht sinchronisierte Version.',
    open_local_version: 'Lokale version öffnen',
    delete_local_version: 'Lokale Version löschen'
  },
  users: 'Benutzer',
  user: {
    name: 'Name',
    password: 'password',
    login: 'Benutzername',
    is_admin: 'Administrator'
  },
  protocol: {
    status: 'Status',
    draft: 'Entwurf',
    not_synchronized: 'Nicht synchronisiert',
    date: 'Datum',
    email_tenant: 'Email Nachmieter',
    email_old_tenant: 'Email Vormieter',
    email_owner: 'Email Eigentümer',
    email_inspector: 'Email Zeuge',
    header: 'AK Immobilienverwaltung GmbH',
    button_save: 'Speichern',
    button_save_and_close: 'Speichern & schließen',
    cause: {
      preliminary: 'Vorabnahme-',
      final: 'Endabnahme-',
      state: 'Zustands-',
      transmission: 'Übergabeprotokoll'
    },
    floor: 'Etage',
    location: {
      left: 'links',
      right: 'rechts',
      middle: 'mitte',
      behind: 'hinten',
      hallway: 'vorn',
      vhs: 'VHS',
      hhs: 'HHS'
    },
    structure_header: 'Die Wohnung besteht aus:',
    structure: {
      room: 'Zimmer',
      bathroom: 'Bad/Dusche mit WC alt/neu',
      restroom: 'WC innen/außen',
      kitchen: 'Küche/Kochnische',
      hallway: 'Diele/Flur',
      balcony: 'Balkon(e)/Wintergarten',
      terrace: 'Terrasse',
      pantry: 'Speisekammer',
      basement: 'Abstellraum',
      basement_number: 'Kellerraum Nr.',
      attic: 'Dachbodenanteil Nr.',
      garden: 'Gartenanteil'
    },
    furniture_header: 'Ausstattung:',
    furniture: {
      heating: {
        district: 'Fernheizung',
        gas: 'Gasetagenheizung',
        central: 'Öl/Gaszentralheizung',
        other: 'Sonstiges'
      },
      tv: {
        antenna: 'Gemeinschaftsantenne',
        cable: 'Kabelanschluß V/M',
        satellite: 'Sat-Anlage V/M '
      },
      other: {
        bicycle_storage: 'Fahrradkeller',
        lift: 'Fahrstuhl',
        intercom: 'Gegensprechanlage',
        shared_washing_machine: 'Gemeinschafts-Waschmaschine',
        floor: 'Trockenkeller/-boden'
      }
    },
    meters_data_header: 'Zählerstände:',
    meters_data: {
      electricity_1: 'Strom 1:',
      electricity_1_data: 'Zählernummer:',
      electricity_2: 'Strom 2:',
      electricity_2_data: 'Zählernummer:',
      gas: 'Gas:',
      gas_data: 'Zählernummer:',
      hot_water_1: 'Warmwasser Bad:',
      cold_water_1: 'Kaltwasser Bad: ',
      hot_water_2: 'Warmwasser Kü.:',
      cold_water_2: 'Kaltwasser Kü.: ',
      heat: 'Wärmemenge:',
      intermediate_counter: 'Zwischenzähler:'
    },
    rooms: {
      button_add: 'Raum hinzufügen',
      kitchen: 'Küche',
      room: 'Raum',
      bathroom: 'Bad',
      guest_bathroom: 'Gäste-WC, 2. Bad',
      access: 'Schlüssel vorhanden',
      hall: 'Flur',
      ceiling: 'Decke',
      walls: 'Wände',
      window: 'Fenster',
      doors: 'Türen',
      radiator: 'Heizkörper',
      radiator_value: 'Stand (kommagetrennt) ',
      plinth: 'Fußleisten',
      floor: 'Fußboden',
      flooring: 'Fußbodenbelag',
      tenants_property: 'Mietereigentum (nicht mitvermietet)',
      notes: 'Notiz',
      boiler_gas: 'Warmwassergastherme',
      boiler_flowing: 'Elt-Durchlauferhitzer',
      boiler_electric: 'Elt-Boiler',
      exist_boiler_other: 'Sonstiges',
      equipment: 'Einbauküche',
      material: 'Holz-/Kunststoff-/Metall-/Doppelfenster/einfach-/iso-verglast',
      tile: 'Terrazzo/Fliesen/PVC-Fußboden',
      other: 'Sonstiges:',
      bathroom_set: 'Badgarnitur',
      bath: 'freistehende/Einbau-Wanne/Duschwanne, WC, Bidet, Spiegel',
      bath_structure: {
        freistehende: 'Freistehende Wanne',
        einbau: 'EinbauWanne',
        dusch: 'Duschwanne',
        wc: 'WC',
        bidet: 'Bidet',
        spiegel: 'Spiegel'
      },
      washbasin: 'Waschbecken, Ablage, Handtuchhalter, Papierhalter, Duschkabine, Wannenaufsatz',
      washbasin_structure: {
        waschbecken: 'Waschbecken',
        ablage: 'Ablage',
        handtuchhalter: 'Handtuchhalter',
        papierhalter: 'Papierhalter',
        duschkabine: 'Duschkabine',
        wannenaufsatz: 'Wannenaufsatz'
      },
      wall_tile: 'Wandfliesen raumhoch, türhoch , -niedriger | Farbe',
      wall_tile_structure: {
        wandfliesen: 'Wandfliesen',
        raumhoch: 'raumhoch',
        halbhoch: 'halbhoch',
        turhoch: 'türhoch | Farbe'
      }
    },
    object: 'Objekt',
    tenant: 'Mieter',
    street: 'Straße',
    signature_owner: 'Eigentümer',
    signature_old_tenant: 'Vormieter',
    signature_inspector: 'Zeuge',
    signature_tenant: 'Nachmieter',
    basement_description: 'Keller',
    balcony_description: 'Balkon',
    remarks: 'Bemerkungen',
    state_header: 'Das Protokoll soll Aufschluss über das Mindestmaß der durchzuführenden Arbeiten und den Zustand ' +
      'der Wohnung geben. Hinzu kommen die Arbeiten, welche 1. zum Zeitpunkt der Besichtigung nicht sichtbar, ' +
      '2. offensichtlich übersehen, 3. verdeckt oder verschwiegen wurden.',
    maintenance_boiler_header: 'Die Thermen-/Heizkesselwartung',
    maintenance_boiler_done: 'wurde am ',
    maintenance_boiler_not_done: 'muss belegt werden',
    maintenance_boiler_executor_owner: 'durch Vermieter',
    warmly_pays: 'Heizkostenverteiler sollen abgelesen werden',
    warmly_pays_tenant: 'ja (Die Kosten der Zwischenablesung trägt/tragen der/die Mieter)',
    warmly_pays_owner: 'nein',
    tenant_eliminate_defects: 'Der Mieter verpflichtet sich, die Mängel vollständig und fachgerecht zu beseitigen bis zum',
    tenant_warned_of_deadline: 'Der/die Mieter wurde darauf hingewiesen, dass bei fruchtlosem Fristablauf der' +
      ' Vermieter berechtigt ist, die Arbeiten durch Fachfirmen auf Kosten der Mieter durchführen zu lassen.',
    repairs_delegates_the_execution: ' Der Mieter beauftragt den Vermieter, die Mängel ',
    repairs_delegates_the_execution2: '. Der Mieter stimmt der Aufrechnung seiner' +
      ' Mietsicherheit zu. Die Mietsicherheit übersteigende Kosten trägt der Mieter.',
    repairs_budget_tenant: 'auf seine Kosten',
    repairs_budget_rent: 'gegen Aufrechnung',
    repairs_budget_rent2: 'mit der Mietsicherheit zu beseitigen bis zum',
    repairs_deadline: 'bis zum',
    tenant_refuses_to_eliminate: 'Der Mieter weigert sich, die Mängel zu beseitigen, weil',
    tenant_eliminate_defects_pays_sum: 'Der Mieter beteiligt sich an den Kosten der Mängelbeseitigung bis zur Höhe von',
    strange_text: 'Der Mieter wurde darauf hingewiesen, dass die Abgabe der Wohnungsschlüssel ohne Anerkennung einer Rechtspflicht im ' +
      'Hinblick auf den Rückgabezustand der Wohnung erfolgt. Maßgebend ist das Protokoll der Bestandsaufnahme.',
    barter: 'Der Nachmieter stellt den Vormieter von seiner Mängelbeseitigungspflicht frei und erhält als Gegenleistung vom Vormieter',
    accept1: 'Der Nachmieter erkennt an, daß ihm die Mieträume in',
    accept2: 'Zustand übergeben wurden. Erkennbare Mängel an der Mietsache hat der Mieter innerhalb eines Monats nach Einzug schriftlich anzuzeigen. ',
    accept3: 'Mit dem Inhalt des Protokolls erkläre(n) ich/wir mich/uns einverstanden.',
    accept_amount_one: 'ich mich',
    accept_amount_some: 'wir uns',
    condition_perfect: 'mängelfreiem',
    condition_satisfactory: 'renoviertem',
    condition_agreement: 'vereinbartem',
    new_address: 'Neue Anschrift:',
    kontoverbindung: 'Kontoverbindung:',
    keys_header: 'Schlüssel',
    keys: {
      house: 'Haus',
      housing: 'Wohnungs',
      mailbox: 'Briefkasten',
      ground: 'Boden',
      vorkeller: 'Vorkeller',
      elevator: 'Keller',
      garages: 'Garagen',
      others: 'Sonstige'
    },
    footer_text: 'Schlüssel wurden heute übergeben.'
  }
}



// WEBPACK FOOTER //
// ./src/language/de.js